<template>
    <v-container fluid>
      <h1 class="page-title">Monitoring service</h1>
      <div v-if="can_see_admin" class="monitoring-overview">
        <Charts />
      </div>
      <div v-else>
        <v-alert shaped type="error" color="red">Access denied</v-alert>
      </div>
    </v-container>
</template>

<script>
    import Charts from '../components/Monitoring/Charts';
    import { monitoringCan } from '../services/monitoring.service';
    export default {
        name: "Monitoring",
        components: {
          Charts
        },
        data: () => ({
          can_see_admin: false
        }),
        computed: {
        },
        methods: {
        },
        mounted() {
          this. can_see_admin =  false;
          if (monitoringCan('see_monitoring', null, null)) {
            this.can_see_admin = true;
          }

        }
    }
</script>

<style scoped>

</style>
